import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';

/**
 * **`React hook`** Provides information about the primary vault in the user’s
 * current profile.
 *
 * @category Instruments
 */
export function usePrimaryVault(profileId?: string) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  return useQuery(tokenizedApi.treasury.primaryVaultQuery(profileId))?.data;
}
